import ScContentTextResults from '@garmin/support-components/src/components/ScContentTextResults/index.vue';
import ScContentVideoResults from '@garmin/support-components/src/components/ScContentVideoResults/index.vue';
import ScPagination from '@garmin/support-components/src/components/ScPagination/index.vue';
import ScContentNoResultsFound from '@garmin/support-components/src/components/ScContentNoResultsFound/index.vue';
import { mapState } from 'pinia';
import { useContentStore } from '../../stores/content/index.js';
import { useGlobalStore } from '../../stores/global/index.js';

import TranslationsMixin from '../../mixins/translations';
import ResultsMixin from '../../mixins/results';
import QueryToNameConverterMixin from '../../mixins/queryToNameConverter';

export default {
  name: 'TheContentResults',
  mixins: [
    TranslationsMixin,
    ResultsMixin,
    QueryToNameConverterMixin,
  ],
  components: {
    ScContentTextResults,
    ScContentVideoResults,
    ScPagination,
    ScContentNoResultsFound,
  },
  computed: {
    ...mapState(useGlobalStore, ['isLoading']),
    ...mapState(useContentStore, [
      'hasResults',
      'contentVideoResults',
      'contentResults',
    ]),
    hasNoContentResults() {
      return (
        !this.hasResults(this.contentVideoResults)
          && !this.hasResults(this.contentResults)
          && !this.isLoading
      );
    },
  },
};
